import { useTranslation } from 'react-i18next';

const PNR_OR_TICKET_NUMBER_REGEX = /(^[0-9БВГДКЛМНПРСТФХЦЖШA-Z]{6,6}$)|(^[0-9A-Z]{3}[0-9]{10}$)/;
const TICKET_NUMBER_REGEX = /(^[0-9A-Z]{3}[0-9]{10}$)/;
const ORDER_NUMBER = /^\d{1,13}$/;
const PASSENGER_LAST_NAME_LATIN_REGEX = /^[- a-zA-Z]{1,41}$/;
const PASSENGER_LAST_NAME_RU_REGEX = /^[- а-яА-ЯЁё]{1,41}$/;

export const isPnrOrTicketNumber = (value: string) => PNR_OR_TICKET_NUMBER_REGEX.test(value);
export const isTicketNumber = (value: string) => TICKET_NUMBER_REGEX.test(value);
export const isOrderNumber = (value: string) => ORDER_NUMBER.test(value);

export const isCorrectLatinLastname = (value: string) => PASSENGER_LAST_NAME_LATIN_REGEX.test(value);
export const isCorrectCyrillicLastName = (value: string) => PASSENGER_LAST_NAME_RU_REGEX.test(value);
export const isSingleWord = (value: string) => value.split(' ').length === 1;

export const useRetrieveBookingValidation = (validationType?: 'common' | 'ticketNumber') => {
	const isTicketNumberValidationType = validationType === 'ticketNumber';

	const { t } = useTranslation('RetrieveBooking');

	const validateByOrderNumber = (value: string): string | void => {
		if (!isOrderNumber(value)) {
			return t('Enter your book code or ticket number') as string;
		}
	};

	const ticketNumberValidation = (value: string): string | void => {
		if (isTicketNumberValidationType) {
			if (!isTicketNumber(value)) {
				return t('Enter your ticket number') as string;
			}
		} else {
			if (!isPnrOrTicketNumber(value)) {
				return t('Enter your book code or ticket number') as string;
			}
		}
	};

	const lastNameValidation = (value: string): string | void => {
		const splittedValue = value?.trim().split(' ') || [];

		if (!splittedValue.every(isCorrectCyrillicLastName) && !splittedValue.every(isCorrectLatinLastname)) {
			return t('Incorrect value') as string;
		} else {
			return undefined;
		}
	};

	const ticketNumberFormat = (value: string): string => {
		return value?.split(' ').join('').slice(0, 13).toUpperCase();
	};

	const requiredValidation = (value: string): string | void => {
		if (!value?.length) {
			return t('Required field') as string;
		}
	};

	const requiredValidationWrapper = (validateFn: (value: string) => string | void) => (value: string) => {
		return requiredValidation(value) || validateFn(value);
	};

	return {
		ticketNumberValidation,
		lastNameValidation,
		validateByOrderNumber,
		ticketNumberFormat,
		requiredValidation,
		requiredValidationWrapper
	};
};
